import React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import picture from "../img/CRMPic.png";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { orange, blue } from '@mui/material/colors';


const theme = createTheme({
  palette: {
    primary: {
      main: orange[500],
    },
    secondary: {
      main: blue[200],
    },
    background: {
      default: "#222222",
    },
  },
});
export default function Login() {
  // const [loading, setLoading] = useState(true);
  const handleSubmit = (event) => {
    // setLoading(true);
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const jsonData = {
        Username: data.get('Username'),
        Password: data.get('Password'),
    }
    fetch('http://27.254.66.164:5000/login',{
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(jsonData),
    })
    .then(response => response.json())
    .then(data => {
            if (data.status === 'Login Success'){
                localStorage.setItem('token', data.token)
                localStorage.setItem('EmpId', data.EmpId)
                localStorage.setItem('EmployeeType', data.EmployeeType)
                localStorage.setItem('name', data.name)
                localStorage.setItem('lastname', data.lastname)
                 window.location = '/ec-crm'
            } else {
                alert('เข้าสู่ระบบไม่สำเร็จ')
            }
        });
  };

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={8}
          md={7}
          sx={{
            backgroundImage: `url(${picture})`,
            backgroundRepeat: 'no-repeat',
            backgroundColor: orange[500],
            backgroundSize: 'contain',
            backgroundPosition: 'center',
          }}
        />

        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 15,
            mx: 15,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography>
                  <img src = {require('./../img/logo.png')} width="150" height="120"  alt="logo" /> 
          </Typography>
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            กรอกข้อมูลเพื่อเข้าสู่ระบบ CRM
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="Username"
                    label="ชื่อผู้ใช้งานระบบ"
                    name="Username"
                    autoComplete="Username"
                    autoFocus
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="Password"
                    label="รหัสผ่าน"
                    type="Password"
                    id="Password"
                    autoComplete="Password"
                  />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              เข้าสู่ระบบ
            </Button>
          </Box>
        </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}